import { OreStack, OreTableCell, OreTableRow, OreText } from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { ContactModel, ContactTypeId } from '@/Store/domain'
import { storesTranslation } from '@/Store/ui/storesTranslation'

interface IProps {
  contact: ContactModel
  isNursery: boolean
}

export const StoreContactRow = ({ contact, isNursery }: IProps): JSX.Element => {
  const { t } = useTranslation()
  const { fullName, email, phone, position } = contact

  const getPosition = (position: ContactTypeId): string => {
    switch (position) {
      case ContactTypeId.owner:
        return t(storesTranslation.contacts.positions.owner)
      case ContactTypeId.manager:
        return t(storesTranslation.contacts.positions.manager)
      case ContactTypeId.billing:
        return t(storesTranslation.contacts.positions.billing)
      default:
        return ''
    }
  }

  return (
    <OreTableRow valign="middle">
      <OreTableCell>
        <OreStack space="small">
          <OreText size="text-sm" bold={isNursery}>{fullName}</OreText>
        </OreStack>
      </OreTableCell>

      <OreTableCell>
        <OreStack space="small">
          <OreText size="text-sm">{email}</OreText>
        </OreStack>
      </OreTableCell>

      <OreTableCell>
        <OreStack space="small">
          <OreText size="text-sm">{phone}</OreText>
        </OreStack>
      </OreTableCell>

      <OreTableCell>
        <OreStack space="small">
          <OreText size="text-sm">{getPosition(position)}</OreText>
        </OreStack>
      </OreTableCell>
    </OreTableRow>
  )
}
